import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import Text from '~components/atoms/Text';
import ActionButton from '~components/atoms/ActionButton';

import RegionsTable from './RegionsTable';
import RegionsCreateNewRegionModal from './RegionsCreateNewRegionModal';
import RegionsPaginator from './RegionsPaginator';

import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_regions.module.scss';
import RegionsDetailsModal from './RegionsDetailsModal';
import RegionsDeleteModal from './RegionsDeleteModal';

const Regions = () => {
    const dispatch = useAppDispatch();

    const handleCreateNewRegionClick = () => dispatch(combinedActions.branchSetCreateNewRegionModalIsOpen(true));

    const createAccessModules = useAppSelector(state => state.auth.userDetails.access)?.find(access => access.permission === PermissionsEnum.Create)?.modules || [];

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>
                <Text
                    label='Regions List'
                    className={Styles.title}
                    size='l'
                    isBold
                />

                {createAccessModules.find(module => module === ModuleEnum.BranchManagement)
                    && (
                        <ActionButton
                            label='+ Create New Region'
                            onClick={handleCreateNewRegionClick}
                        />
                    )
                }
            </TabPageHeaderWrapper>

            <RegionsTable />

            <RegionsPaginator />

            <RegionsCreateNewRegionModal />

            <RegionsDetailsModal />

            <RegionsDeleteModal />
        </TabPageContainer>
    );
};

export default Regions;
